import { CLASSES } from "@/scripts/helpers/constants";

export const clearFocusedElements = () => {
  $(":focus").blur();
};

export const getScrollBarWidth = function() {
  const inner = document.createElement("p");
  inner.style.width = "100%";
  inner.style.height = "200px";

  const outer = document.createElement("div");
  outer.style.position = "absolute";
  outer.style.top = "0px";
  outer.style.left = "0px";
  outer.style.visibility = "hidden";
  outer.style.width = "200px";
  outer.style.height = "150px";
  outer.style.overflow = "hidden";
  outer.appendChild(inner);

  document.body.appendChild(outer);
  const w1 = inner.offsetWidth;
  outer.style.overflow = "scroll";
  let w2 = inner.offsetWidth;
  if (w1 === w2) w2 = outer.clientWidth;

  document.body.removeChild(outer);

  return w1 - w2;
};

export const attachIE11helper = () => {
  if (navigator.userAgent.match(/Trident.*rv:11\./))
    $("body").addClass("is-ie11");
};

export const attachEdgeBrowserHelper = () => {
  if (/Edge/.test(navigator.userAgent)) $("body").addClass("is-edge");
};

export const attachFirefoxBrowser = () => {
  if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1)
    $("body").addClass("is-firefox");
};

export const attachSafariBrowser = () => {
  if (
    navigator.userAgent.search("Safari") >= 0 &&
    navigator.userAgent.search("Chrome") < 0
  )
    $("body").addClass("is-safari");
};

export const attachJQueryPlugins = function() {
  if ($) {
    $.fn.inView = function() {
      const win = $(window);
      const obj = $(this);
      const scrollPosition = win.scrollTop();
      const visibleArea = win.scrollTop() + win.height();
      const objEndPos = obj.offset().top;

      return visibleArea >= objEndPos && scrollPosition <= objEndPos;
    };
  }
};

export const bindJQuery = function() {
  window.$ = window.JQuery = $;

  attachJQueryPlugins();
};

export const reloadCachedPage = callback => {
  if ($("body").hasClass("is-safari")) {
    $(window).bind("pageshow", function(event) {
      if (event.originalEvent.persisted) {
        window.location.reload();
      }
    });
  }
};

export const checkWebpSupport = () => {
  function supportsWebp() {
    if (!self.createImageBitmap) return false;

    const webpData = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",
          blob = fetch(webpData).then(r => r.blob());

    return createImageBitmap(blob).then(() => true, () => false);
  }

  if(supportsWebp()) {
    $("body").addClass("webp-does-support");
  }
};

export const debounce = (fn, delay) => {
  let timeoutId;

  return function(...args) {
    if (timeoutId) clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

export const reloadPageIfLoadedFromCache = () => {
  $(window).bind("pageshow", function(e) {
    if (
      e.persisted ||
      e.originalEvent.persisted ||
      window.performance.navigation.type == 2
    ) {
      if (document.documentMode) window.location = window.location;
      window.location.reload();
    }
  });
};

export const showMore = (targetBlockClass, triggerClass, triggerTextClass) => {
  const targetBlock = document.querySelector(targetBlockClass);
  const trigger = document.querySelector(triggerClass);
  const shortState = "Show more";
  const expandedState = "Show less";
  let offsetTop = 0;
  let opened = false;

  if (trigger) {
    const triggerText = trigger;

    trigger.addEventListener("click", e => {
      e.preventDefault();

      const currState = trigger.getAttribute("data-visible-state");

      if (!opened) offsetTop = window.pageYOffset;

      triggerText.innerText = currState;
      trigger.classList.toggle(CLASSES.IS_OPEN);
      trigger.setAttribute(
        "data-visible-state",
        currState === shortState ? expandedState : shortState
      );

      if (targetBlock) targetBlock.classList.toggle(CLASSES.IS_OPEN);

      if (currState === expandedState) {
        window.scrollTo(0, offsetTop);
        opened = true;
      }

      if (currState === shortState) {
        window.scrollTo(0, offsetTop);
        opened = false;
      }
    });
  }
};

export const detectDevice = () => {
  const uploaderSection = $(".page-section--feature-teasers");
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    uploaderSection.addClass(CLASSES.IS_HIDDEN);
  }
};

export const detectPhoneOs = () => {
  const tabletBreakpoint = 960;
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (window.innerWidth < tabletBreakpoint){
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      $("body").addClass("is-windows-phone");
    }

    if (/android/i.test(userAgent)) {
      $("body").addClass("is-android");
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      $("body").addClass("is-ios");
    }
  }
};
